/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { TranslationService } from '@gh/core-mls';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  selector: 'gh-user-list',
  template: require('./user-list.component.html'),
  styles: [],
})
export class UserListComponent {
  get parentTitle(): string {
    const label = this.userContext.corporateView ? 'lbl_menu_corporate_users' : this.userContext.masterView ? 'lbl_menu_master_users' : 'lbl_menu_users';
    return this.translationService.get(label);
  }
  constructor(private translationService: TranslationService, private userContext: BuilderUserContext) {
  }
}
